import { render, staticRenderFns } from "./MiniCourseCard.vue?vue&type=template&id=56cf930d&scoped=true"
import script from "./MiniCourseCard.vue?vue&type=script&lang=js"
export * from "./MiniCourseCard.vue?vue&type=script&lang=js"
import style0 from "./MiniCourseCard.vue?vue&type=style&index=0&id=56cf930d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cf930d",
  null
  
)

export default component.exports